import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  pagosRegistradosList,
  pagosRegistradosListSelectBox,
  pagosRegistradosRead 
} = actions;


const pagosRegistradosListAction = ( { fecha_inicio , fecha_fin, saldo , idSucursal, idServicio , idFormaPago  }) => {
//const pagosRegistradosListAction = ( paramBusqueda = '') => {
 
  console.log("-----------pagosRegistradosListAction----------------");
  console.log(fecha_inicio);
  console.log(fecha_fin);
  console.log(saldo);
  console.log(idSucursal);
  console.log(idServicio);
  console.log(idFormaPago);

let arrayFechaInicio = []
let fecha_inicio_aux = ''
let arrayFechaFin = []
let fecha_fin_aux = ''

if(fecha_inicio != ''){
     arrayFechaInicio = fecha_inicio.split("-");
     fecha_inicio_aux = arrayFechaInicio[2] + "-" + arrayFechaInicio[1] + "-" + arrayFechaInicio[0]
}
if(fecha_fin != ''){
  arrayFechaFin = fecha_fin.split("-");
  fecha_fin_aux = arrayFechaFin[2] + "-" + arrayFechaFin[1] + "-" + arrayFechaFin[0]
}

  return async dispatch => {
    try {
      //const response = await DataService.get('/finanzas/list.php?paramBusqueda=' + paramBusqueda);    
      const response = await DataService.get('/finanzas/list.php?idServicio=' + idServicio + "&idSucursal=" + idSucursal + "&idFormaPago=" + idFormaPago + '&saldo=' + saldo + '&fecha_inicio=' + fecha_inicio_aux + '&fecha_fin=' + fecha_fin_aux );      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(pagosRegistradosList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pagosRegistradosReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/finanzas/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(pagosRegistradosRead(response.data.data));
          return true;
        }
      } else {
        dispatch(pagosRegistradosRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  pagosRegistradosListAction,
  pagosRegistradosReadAction,    
};
